import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import {
  DlpKeywordListModalNameEnum,
  DlpKeywordListModalState,
} from '../../type';

export const ImportModal = ({
  modalState,
  onClose,
}: {
  modalState: DlpKeywordListModalState;
  onClose: () => void;
  refreshTable: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={modalState.name === DlpKeywordListModalNameEnum.Import}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalBody>
          <Text>{modalState.name}</Text>
        </ModalBody>
        <ModalFooter>
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
